var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.925 19.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 17.925,
    height: 19.576,
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_185",
    "data-name": "Trac\\xE9 185",
    d: "M17.892,12.211a.632.632,0,0,0-.8-.4h0l-2.136.709-.758-.437.474-.821a.631.631,0,0,0-1.094-.631l-.474.821-1.112-.642V8.768l1.113-.643.474.821a.631.631,0,0,0,1.094-.631L14.2,7.493l.758-.437,2.137.711a.63.63,0,0,0,.8-.4h0a.631.631,0,0,0-.4-.8h0L16.42,6.211l.789-.455a.632.632,0,0,0-.631-1.094l-.789.455.228-1.108a.629.629,0,0,0-.49-.743h0a.631.631,0,0,0-.746.491h0l-.454,2.2-.758.437-.474-.821A.631.631,0,1,0,12,6.209l.474.821-1.112.642L9.594,6.653V5.368h.947a.631.631,0,0,0,0-1.263H9.594V3.231l1.683-1.494a.632.632,0,0,0-.836-.949h0l-.845.752V.631a.631.631,0,0,0-1.263,0v.91L7.488.792a.631.631,0,0,0-.84.943l1.684,1.5V4.1H7.384a.631.631,0,0,0,0,1.263h.947V6.653L6.563,7.673,5.45,7.03l.474-.821a.632.632,0,1,0-1.094-.631L4.356,6.4,3.6,5.962l-.452-2.2a.632.632,0,0,0-1.238.25v0c.066.321.149.726.228,1.108l-.789-.455A.631.631,0,0,0,.715,5.756l.789.455L.434,6.568a.632.632,0,0,0,.394,1.2h0l2.138-.71.758.437-.474.821a.632.632,0,1,0,1.094.631l.474-.821,1.111.642v2.041l-1.113.643-.474-.821a.631.631,0,1,0-1.1.624l0,.007.474.821-.758.437L.832,11.809a.632.632,0,0,0-.4,1.2h0l1.074.356-.789.455a.632.632,0,0,0,.632,1.094l.789-.455L1.91,15.563a.631.631,0,0,0,1.236.256L3.6,13.613l.758-.437L4.832,14a.631.631,0,0,0,1.094-.631l-.474-.821,1.11-.641,1.768,1.019v1.286H7.384a.631.631,0,1,0,0,1.263h.947v.874l-1.684,1.5a.631.631,0,0,0,.84.943l.844-.75v.91a.631.631,0,1,0,1.263,0v-.91l.845.752a.629.629,0,0,0,.888-.052v0a.631.631,0,0,0-.052-.891l-1.683-1.5v-.874h.947a.631.631,0,0,0,0-1.263H9.594V12.923L11.362,11.9l1.113.643L12,13.367A.631.631,0,0,0,13.1,14l.474-.821.758.437c.05.241.3,1.452.454,2.207a.629.629,0,0,0,.743.489h0a.631.631,0,0,0,.491-.746L15.79,14.46l.789.455a.631.631,0,0,0,.631-1.094l-.789-.455,1.074-.356a.629.629,0,0,0,.4-.8Zm-7.435-1.56-1.494.863L7.468,10.65V8.926l1.494-.863,1.494.863Z",
    transform: "translate(0)",
    fill: "current"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.3cbe8e70db3a414b81de43aa29fc994a.svg";
export { ForwardRef as ReactComponent };